<template>
  <div class="forms__field-wrapper" :class="extraClasses">
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <div class="input-wrapper" :class="{ 'error': showFormError,  'required': required }">
      <input class="input"
        type="tel"
        :placeholder="label"
        :id="id"
        :required="required"
        v-model="value"
        @blur="validateField"
        />
      <label class="floating-label" :for="id">{{ label }}</label>
      <template v-if="showFormError">
        <p class="forms__error-message" v-t="'errors.required_field'" role="alert"/>
      </template>
    </div>
  </div>
</template>

<script>
import AbstractField from "@/util/AbstractField";

export default {
  name: 'input-tel',
  mixins: [AbstractField],
}
</script>